import React from 'react';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseStyles = 'px-6 py-2.5 rounded-full font-medium transition-all duration-300 transform hover:scale-105 active:scale-95 flex items-center justify-center';
  
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-dark shadow-lg hover:shadow-primary/30',
    secondary: 'bg-white text-primary border-2 border-primary hover:bg-primary/5',
    outline: 'bg-transparent text-white border-2 border-white/50 hover:bg-white/10',
    dark: 'bg-navy text-white hover:bg-navy-light',
    ghost: 'bg-transparent text-navy hover:bg-navy/5',
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
